




































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Password from '@/components/inputs/Password.vue'
import { UserModule } from '@/store/modules/user.module.ts'
import { validatePassword } from '@/utils/helpers'
import Api from '@/api'
import { NoCache } from '@/decorators/NoCache'
import ErrorMessages from '@/components/ErrorMessages.vue'

@Component({
  components: {
    ErrorMessages,
    Icon,
    Password
  }
})
export default class ResetPassword extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  errors: Array<string> = []
  password: string = ''
  repeatPassword: string = ''

  @NoCache
  get redirectUrl () {
    const user = Api.getUser()
    if (user && user.isDataEntry()) {
      return { name: 'admin-uploads' }
    }
    if (user && user.isManager()) {
      return { name: 'management-todo' }
    }
    if (user && user.isAdmin()) {
      return { name: 'admin-chains' }
    }
    return { name: 'login' }
  }

  validate () {
    const errors = []
    if (this.password !== this.repeatPassword) {
      errors.push('Passwords are not a same')
    }
    if (!validatePassword(this.password)) {
      errors.push('Password must contain 8 characters with at least one upper case and one lower case character')
    }
    this.errors = errors
    return this.errors.length === 0
  }

  async reset () {
    if (!this.validate()) {
      return
    }

    const response = await this.userModuleInstance.resetPassword({
      password: this.password,
      key: this.$route.query.key ? this.$route.query.key as string : 'dummykey'
    })

    if (response === 'OK') {
      this.$router.push(this.redirectUrl)
    } else if (response === 'forbidden') {
      this.errors.push('User Is Deactivated')
    } else {
      this.errors.push('Invalid Token')
    }
  }
}
